import { jsx as _jsx } from "react/jsx-runtime";
import { FiatDetailsScreen } from "./FiatDetailsScreen.js";
import { SwapDetailsScreen } from "./SwapDetailsScreen.js";
export function TxDetailsScreen(props) {
    const { statusInfo } = props;
    if (statusInfo.type === "swap") {
        return (_jsx(SwapDetailsScreen, { client: props.client, status: statusInfo.status, onBack: props.onBack }));
    }
    if (statusInfo.type === "fiat") {
        return (_jsx(FiatDetailsScreen, { title: props.title, client: props.client, status: statusInfo.status, onBack: props.onBack, onDone: props.onDone, transactionMode: props.transactionMode, isEmbed: props.isEmbed, payer: props.payer }));
    }
    return null;
}
//# sourceMappingURL=TxDetailsScreen.js.map